import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import StoryHero from "./components/StoryHero";
import StoryContent from "./components/StoryContent";
import StoryValues from "./components/StoryValues";

export default function Story() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <StoryHero />
        <StoryContent />
        <StoryValues />
      </main>
      <Footer />
    </div>
  );
}
